import LineItem from '../modules/Cart/classes/LineItem.js'

(function() {
	"use strict"

	angular.module( "ATMGurus" )

	.controller( "SingleProductController", [
		"User",
		"$location",
		"Auth",
		"ATMGConf",
		"$scope",
		"Api.Store",
		"fetchProduct",
		"Loader",
		function(User, $location, Auth, Conf, $scope, Store, Product, Loader) {

			var User = User.getUserData()

			Loader.hide()

			this.trust = function(content) {
				return $sce.trustAsHtml(content)
			}

			var lineItem = new LineItem(Product)

			lineItem.quantity = 1

			this.selectedItem = lineItem; //{details: Product, quantity: 1};
			this.store = Store;
			this.User = User;
			this.MainCtrl = $scope.$parent.MainCtrl;

			/**
			*	openGallery
			*/
			this.openGallery = function(img, productDetails) {
				$scope.$emit('modal.open', {
					title: productDetails.title,
					template: 'gallery',
					visible: true,
					data: {
						imgSrc: img
					}
				})
			}

			/**
			*	launchVideo
			*/
			this.launchVideo = function(video) {
				$scope.$emit('modal.open', {
					title: lineItem.title,
					template: 'video_player',
					visible: true,
					data: {
						embed_url: video.embed_url
					}
				})
			}

			this.addToCart = function( ) {
				Auth.isLogged()
					.then(function addItemToCart(response) {
						if (! response) {
							$location.url("/login?urlback=" + $location.path() );
							return false
						}
					})
					.catch(() => {
						$location.url("/login?urlback=" + $location.path() );
						return false
					})

				return User.Cart.addItem(this.selectedItem)
			}
		}
	])

})()


// WEBPACK FOOTER //
// ./src/app/controllers/SingleProductController.js